module.exports = __webpack_public_path__ + "img/userinfo.88ff23a3.svg";